<template>
  <div class="product">
      <h1 @click="toPro">产品</h1>
      <div class="items">
        <div class="item" @click="toMecPro('mec_pr')">
          <img src="~static/img/index/products.png" alt="" />
          <p>MEC产品</p>
        </div>
        <div class="item" @click="toMecPro('mec_live')">
          <img src="~static/img/index/stream_live.png" alt="" />
          <p>MEC+VR直播产品</p>
        </div>
        <div class="item" @click="toMecPro('mec_control')">
          <img src="~static/img/index/monitor.png" alt="" />
          <p>MEC+监控产品</p>
        </div>
        <div class="item" @click="toMecPro('mec_iot')">
          <img src="~static/img/index/IOT.png" alt="" />
          <p>MEC+IoT产品</p>
        </div>
        <div class="item" @click="toMecPro('mec_ai')">
          <img src="~static/img/index/AI.png" alt="" />
          <p>MEC+AI产品</p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  methods: {
    toMecPro(type) {
      location.href=`product.html?type=${type}`
    },
    toPro() {
      location.href="product.html"
    }
  }
}
</script>

<style lang="scss" scoped>
  .product {
    height: 426px;
    background-color: #fff;
    padding-top: 98px;
    box-sizing: border-box;
    h1 {
      color: #2C3B5C;
      font-size: 36px;
      line-height: 36px;
      margin-bottom: 40px;
      text-align: center;
      cursor: pointer;
      /* font-family:PingFangSC-Semibold; */
    }
    .items {
      display: flex;
      justify-content: center;
      .item {
        text-align: center;
        /* margin-right: 80px; */
        margin-right: 94px;
        cursor: pointer;
        p {
          color: #2C3B5C;
          font-size: 18px;
          line-height: 18px;
          font-weight: bold;
          padding-top: 14px;
        }
        img {
          width: 120px;
          height: 120px;
        }
      }
      /* .item:first-child {
        margin-right: 66px;
      }
      .item:nth-child(2) {
        margin-right: 64px;
      } */
      .item:last-child {
        margin-right: 0;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/index/product.vue